import React from "react";
import { SITE } from "../lib/site";
import { MessageCircleMore } from "lucide-react";

export default function WhatsAppButton() {
  const number = SITE.phones[0].replace(/\s/g, "").replace("+", "");
  const text = encodeURIComponent(
    "Ciao Edil Murgia! Vorrei avere informazioni su un possibile intervento."
  );
  const href = `https://wa.me/${number}?text=${text}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Scrivici su WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed bottom-5 left-5 z-50 group flex items-center gap-2 pl-3 pr-4 py-3 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white shadow-2xl transition-all duration-200 hover:scale-[1.03]"
    >
      <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-white/15">
        <MessageCircleMore className="h-5 w-5" />
        <span className="absolute -top-0.5 -right-0.5 h-3 w-3 rounded-full bg-brand-terracotta border-2 border-[#25D366] animate-pulse-soft" />
      </span>
      <span className="hidden sm:inline-flex flex-col leading-tight">
        <span className="text-[10px] uppercase tracking-[0.18em] text-white/80">WhatsApp</span>
        <span className="text-sm font-semibold">{SITE.phones[0]}</span>
      </span>
    </a>
  );
}
